import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabaseClient';

export interface UseAppSettingResult<T> {
  value: T | null;
  isLoading: boolean;
  isError: boolean;
}

export function useAppSetting<T = unknown>(key: string): UseAppSettingResult<T> {
  const query = useQuery({
    queryKey: ['app-setting', key],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('app_settings_get', {
        payload: { key },
      });

      if (error) {
        console.error(`[useAppSetting:${key}] Error:`, error);
        return null;
      }

      const value = (data as any)?.items?.[0]?.value;
      return (value ?? null) as T | null;
    },
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    retry: 1,
  });

  return {
    value: (query.data ?? null) as T | null,
    isLoading: query.isLoading,
    isError: query.isError,
  };
}
